<template lang="pug">
  .select-technician
    div
      button.change-button(
        :disabled="disabled || loading"
        @click="showModal"
        @hide="hideModal()"
      ) Dar reingreso
        b-spinner(v-if="loading" class="ml-2" variant="white" small)
    //- Modal para dar reingreso a una OT
    SamtekModal(
      :title="`Dar reingreso a OT ${ot.ot}`" 
      v-model="modal" 
      id="selectTechnician"
      confirmText="Confirmar reingreso"
      cancelText="Cancelar"
      :loading="loading"
      @shown="onModalShown"
      @hide="onModalHide"
      @confirm="darReingreso"
      @cancel="hideModal"
    )
      div.d-block.text-center
        p Se cerrará la orden actual y creará una nueva con características similares
        b-form-input(v-model="informeDeFalla")
</template>

<script>
import { mapActions } from 'vuex'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'

/** Cierra OT actual y crea una nueva
 * con caraterísticas similares
 */

export default {
  components: {
    SamtekModal: () => import('@/components/Common/SamtekModal.vue'),
  },
  name: 'ActionReingreso',
  mixins: [LoadingButtonMixin],
  props: ['ot', 'disabled'],
  data() {
    return {
      informeDeFalla: this.ot?.diagnostico_detail?.informe,
      modal: false,
    }
  },
  methods: {
    ...mapActions('OTStore', ['reingreso']),
    ...mapActions('TechniciansStore', ['listTechnicians']),
    showModal() {
      this.startLoading()
      this.modal = true
    },
    onModalShown() {
      this.stopLoading()
    },
    onModalHide() {
      this.stopLoading()
    },
    hideModal() {
      this.modal = false
    },
    async darReingreso() {
      try {
        await this.executeWithLoading(
          async () => {
            const res = await this.reingreso({
              otId: this.ot.ot,
              informeDeFalla: this.informeDeFalla,
            })
            const newOT = res.data
            this.$bvToast.toast(
              `Reingreso exitoso, se generó nueva OT ${newOT.ot}`,
              {
                variant: 'success',
                'auto-hide-delay': 6000,
              }
            )

            // Simular delay adicional para mostrar el mensaje
            await new Promise((resolve) => setTimeout(resolve, 3000))

            this.$emit('changed')
            console.log('to', `/editar-orden/${newOT.ot}`, newOT)
            this.$router.push(`/editar-orden/${newOT.ot}`)
            await this.listTechnicians({ forceReload: true })
            this.modal = false
          },
          { delay: 500 }
        ) // Delay más largo para operación crítica
      } catch (err) {
        console.error('Error en reingreso:', err)
        this.$bvToast.toast(
          err.response?.data || 'Error al procesar reingreso',
          {
            variant: 'danger',
          }
        )
      }
    },
  },
}
</script>
